import { CENTRAL_HUB_BASE_URL } from 'src/environments/base-url';

export const getChangeLogFiltersUrl = (): string => `${CENTRAL_HUB_BASE_URL}/changelog/filters`;

export const getChangeLogRolesUrl = (): string => `${CENTRAL_HUB_BASE_URL}/changelog/roles`;

export const getChangeLogUrl = (): string => `${CENTRAL_HUB_BASE_URL}/changelog/search`;

export const getChangeLogTemplatesUrl = (): string => `${CENTRAL_HUB_BASE_URL}/changelog/metadata/templates`;

export const getChangeLogKeysUrl = (): string => `${CENTRAL_HUB_BASE_URL}/changelog/metadata/keys`;
